import React from 'react'

export function HelpTooltip(props) {
  return (
    <span
      aria-live="assertive"
      aria-describedBy={props.ariaDescribedBy}
      className="helpful-tooltip"
    >
      {props.message}
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/HelpTooltip.js